import './UnityRoom.css'
import { GetExteriorImage, GetFloorImage, GetInteriorImage } from '../UnityFirebaseCalls/FirebaseGetImage'
import { Carousel } from 'react-responsive-carousel';
import { onUnityUpdateMessage } from '../UnityLogic/ReceiveMessage';
import * as SHOW_DECOR  from '../../../constants/showDecor'

export function UnityRoom(thisRoom){

    console.log("This Room Data " , thisRoom);
    //this room needs
    //room name
    // floor plan
    // interior image
    //GetInteriorImage(thisRoom.unitId, thisRoom.id ,"unitInterior" + thisRoom.id);
    GetInteriorImage(thisRoom.unitId, thisRoom.id + "floor" ,"unitFloor" + thisRoom.id);
    return(<div className="layout_room_unity">
            <h2>{thisRoom.roomName}</h2>
            <button onClick={()=>{
                    console.log("This room Information ", thisRoom);
                    if(SHOW_DECOR.showDecor === true)
                    {
                        onUnityUpdateMessage.getRoomUpgrades(thisRoom.id, thisRoom.unitId);
                    }
                    onUnityUpdateMessage.goToRoom(thisRoom.id, thisRoom.unitId);
                    onUnityUpdateMessage.zoomTo("0");
                }}>Enter Room</button>
            <div className="layout_room_image_holder_unity">
                <img className="layout_room_image_unity" id={"unitFloor" + thisRoom.id} alt="exterior"></img>
            </div>
        </div>)
}


// populateRooms(roomJson, parentToAppend, parentList){

//     var populatingRoomJson = roomJson;

//     this.lastRoomSetJson = roomJson;

//     this.clearThisUI(parentList);

//     var theseKeys = [];

//     for(var key in roomJson){
//         theseKeys.push(key);
//     }

//     theseKeys.forEach((key)=>{
    
//         populatingRoomJson[key].forEach((room)=>{
//             var unitButton = document.createElement('button');
//             unitButton.innerHTML = room.roomName;

//             parentToAppend.append(unitButton);

//             unitButton.onclick = () =>{
//                 console.log("Get room upgrade " + room.id); 
//                 this.currentRoomId = room.id;
//                 this.getRoomUpgrades(room.id, this.currentUnitId);
//                 this.goToRoom(room.id, this.currentUnitId);
//             }

//             //createRoomUI

//             parentList.push(unitButton);
//         });

//     });

//     //this.addGoBackButton();


//     this.bothUIOpen();

//             //this.currentUiState = "inCategory";
//     if(parentToAppend === this.leftUiHolder){
//         this.leftUiTitle.innerHTML = "Rooms";
//     }
//     else if(parentToAppend === this.rightUiHolder){
//         this.rightUiTitle.innerHTML = "Rooms";
//     }
      
// }
